import type { FC } from 'react'
import { useTranslation } from 'next-i18next'
import Link from 'next/link'

type Props = {
    isSubscribed: boolean
    subscriptionMessage?: string
    noSubscriptionMessage?: string
}
export const NewsletterCard: FC<Props> = ({
    isSubscribed,
    subscriptionMessage = 'You are subscribed to General Subscription',
    noSubscriptionMessage = "You aren't subscribed to our newsletter."
}) => {
    const { t } = useTranslation(['account'])

    return (
        <div className="newsletter-container box-info">
            <h2 className="box-info-title">{t('account|Newsletters')}</h2>
            {isSubscribed
                ? t(`account||account|${subscriptionMessage}`)
                : t(`account||account|${noSubscriptionMessage}`)}
            <div className="action-container">
                <Link href="/account/newsletter">{t('account|Edit')}</Link>
            </div>
        </div>
    )
}
